import { getDateTime, getDay } from "../getDate"

export const joinDate = (date: string, isNotTime?: boolean) =>
  date
    .split("｜")
    ?.map((dateTime) => (isNotTime ? getDay(dateTime) : getDateTime(dateTime)))
    ?.join("｜") || ""
